import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../../commons/services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { runInThisContext } from 'vm';

@Component({
  selector: 'app-histo-prest',
  templateUrl: './histo-prest.component.html',
  styleUrls: ['./histo-prest.component.css']
})
export class HistoPrestComponent implements OnInit {
  @Input() prestation

  @ViewChild('msg') msg;
  @ViewChild('templateSupressionFille') templateSupressionFille;

  @Output() hidefunction = new EventEmitter<any>();
  @Output() recreate = new EventEmitter<any>();
  @Output() annuleUneLocation = new EventEmitter<any>();


  selectedLocation: any = {};
  isEditLocation: Boolean = false;
  isEdit: Boolean = false;
  isModeEquipe: Boolean = false;
  objEquipe: any = {};
  is_recreate: Boolean = false;
  loadingIndicator: Boolean = false;
  copyEquipe;
  motifAnnulationFille = '';
  rowToDelete;
  heightTableau: any = 'auto';
  rows = [];
  selected: any = [];
  page = 0;
  orderBy = '';
  isAsc = false;
  rowCount = 0;
  nbPage = 0;
  error = '';

  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    this.getListeHisto();
  }

  getListeHisto() {
    this.rows = [];
    this.loadingIndicator = true;
    const param = {
      'servlet': 'DBGetListLocationMateriel',
      'module': 'Ecoloc',
      'type': 'map',
      'compression': 'true',
      'data': {
        'CLEF_CLIENT': '' + (this.prestation && this.prestation.client ? (this.prestation.client.id || 0) : 0),
        'CLEF_TYPE_CAMION': '0',
        'NEPAS_UTILISER_FILTRE_REALISATION': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'LOCATION_REALISEE': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CAMION': {
          'typeParam': 'int',
          'valeur': 0
        },
        'CLEF_CHAUFFEUR': {
          'typeParam': 'int',
          'valeur': 0
        },
        'CLEF_AGENCE': {
          'typeParam': 'int',
          'valeur': 0
        },
        'CLEF_CHANTIER': {
          'typeParam': 'int',
          'valeur': 0
        },
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0]
        },
        'CLEF_SERVICE': {
          'typeParam': 'int',
          'valeur': 0
        },
        'CLEF_LOCATION_MATERIEL': {
          'typeParam': 'int',
          'valeur': 0
        },
        'CLEF_CONTRAT': {
          'typeParam': 'int',
          'valeur': 0
        },
        'CLEF_PERIODE': {
          'typeParam': 'int',
          'valeur': 0
        },
        'CLEF_TYPE_CHAUFFEUR': {
          'typeParam': 'int',
          'valeur': 0
        },
        'NUMERO_PAGE': {
          'typeParam': 'int',
          'valeur': this.page || 0
        },
        'COLUMN_TRIE': this.orderBy || '',
        'ORDRE_TRIE': (this.orderBy ? (this.isAsc ? 'ASC' : 'DESC') : ''),
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        console.log(datas.data);
        this.rows = datas.data.LIST_BON || [];
        this.nbPage = datas.data.NB_PAGES || 0;
        this.rowCount = datas.data.NB_BON || 0;
        this.loadingIndicator = false;
      }
    }).catch(e => this.loadingIndicator = false);
  }

  sortBy(name) {
    this.orderBy = name;
    this.isAsc = !this.isAsc;
    this.rows = [];
    this.loadingIndicator = true;
    this.getListeHisto();
  }

  fermer() {
    this.hidefunction.emit();
  }

  recreatePresta() {
    if (this.selected && this.selected.length) {
      this.recreate.emit(this.selected[0]);
    } else {
      this.error = 'Veillez séléctionner une ligne de prestation.';
      this.common.openModal(this.modalService, this.msg)
    }

  }

  onFooterPage(event) {
    this.page = event.page - 1;
    this.loadingIndicator = true;
    this.getListeHisto();
  }

  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    
  }


}

